"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HMH_NOTIFICATIONS_WEBLAB_NAME = exports.HMH_LOADED = exports.EMIT_MESSAGES = void 0;
var EMIT_MESSAGES = exports.EMIT_MESSAGES = {
  HMH_RENDER_INGRESS: 'hmh_render_ingress',
  HMH_RENDER_INGRESS_LIST_HEADER: 'hmh_render_ingress_list_header',
  HMH_CLOSE_EVENT: 'hmh_close_flyover',
  HMH_SHOW_TOOLTIPS: 'show_tooltips',
  HMH_HIDE_TOOLTIPS: 'hide_tooltips',
  HMH_OPEN_FLYOVER: 'hmh_open_flyover'
};
var HMH_LOADED = exports.HMH_LOADED = 'hmh_loaded';
var HMH_NOTIFICATIONS_WEBLAB_NAME = exports.HMH_NOTIFICATIONS_WEBLAB_NAME = 'HMH_NOTIFICATIONS_IN_HEADER_QUESTION_MARK';
//# sourceMappingURL=constants.js.map